export const _labelLg1 = `
	font: var(--_label-lg-1-font);
	letter-spacing: var(--_label-lg-1-letter-spacing);
`

export const _labelLg2 = `
	font: var(--_label-lg-2-font);
	letter-spacing: var(--_label-lg-2-letter-spacing);
`

export const _labelLg3 = `
	font: var(--_label-lg-3-font);
	letter-spacing: var(--_label-lg-3-letter-spacing);
`

export const _labelMd1 = `
	font: var(--_label-md-1-font);
	letter-spacing: var(--_label-md-1-letter-spacing);
`

export const _labelMd2 = `
	font: var(--_label-md-2-font);
	letter-spacing: var(--_label-md-2-letter-spacing);
`

export const _labelMd3 = `
	font: var(--_label-md-3-font);
	letter-spacing: var(--_label-md-3-letter-spacing);
`

export const _labelSm1 = `
	font: var(--_label-sm-1-font);
	letter-spacing: var(--_label-sm-1-letter-spacing);
`

export const _labelSm2 = `
	font: var(--_label-sm-2-font);
	letter-spacing: var(--_label-sm-2-letter-spacing);
`

export const _labelSm3 = `
	font: var(--_label-sm-3-font);
	letter-spacing: var(--_label-sm-3-letter-spacing);
`

export const _placeholderSm = `
	font: var(--_placeholder-sm-font);
	letter-spacing: var(--_placeholder-letter-spacing);
`

export const _placeholderLg = `
	font: var(--_placeholder-lg-font);
	letter-spacing: var(--_placeholder-letter-spacing);
`

export const _supportText = `
	font: var(--_support-text-font);
	letter-spacing: var(--_support-text-letter-spacing);
`